"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgDepartmentSelectorCtrl = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
class OrgDepartmentSelectorCtrl {
    constructor(includeOtherAdminOrgs = false) {
        this.includeOtherOrgs = includeOtherAdminOrgs;
    }
    get loadingDepartments() {
        return services_1.Services.Department.current != null && services_1.Services.Department.departments.length === 0;
    }
    get departmentOptions() {
        const currentDepartment = services_1.Services.Department.current;
        if (currentDepartment == null || currentDepartment.orgId == null) {
            return [];
        }
        const moveableDepartments = services_1.Services.Department.moveableDepartments();
        // For some weird reason office uses the key as the display, and its value as its key on the <option> element????
        return moveableDepartments.map((department) => ({
            key: `${department.displayName}${currentDepartment.orgId === department.orgId ? '' : ' (Outside Org)'}`,
            value: department.objectId,
        }));
    }
    selectDepartment(departmentId) {
        this.selectedDepartmentId = departmentId;
    }
}
exports.OrgDepartmentSelectorCtrl = OrgDepartmentSelectorCtrl;
tslib_1.__decorate([
    mobx_1.observable
], OrgDepartmentSelectorCtrl.prototype, "selectedDepartmentId", void 0);
tslib_1.__decorate([
    mobx_1.computed
], OrgDepartmentSelectorCtrl.prototype, "loadingDepartments", null);
tslib_1.__decorate([
    mobx_1.computed
], OrgDepartmentSelectorCtrl.prototype, "departmentOptions", null);
tslib_1.__decorate([
    mobx_1.action
], OrgDepartmentSelectorCtrl.prototype, "selectDepartment", null);
//# sourceMappingURL=org.department.selector.ctrl.js.map